export enum PricingTerm {
  MONTHLY = 'monthly',
  FULL_TERM = 'full_term',
}

export const PricingTermArray = Object.values(PricingTerm);
